import React from 'react';
import {
  PhonicsLessonGroup,
  PhonicsLesson,
  PhonicsClassStatus,
} from '@/api/types';
import { ManageGroupSelect } from './ManageGroupSelect';
import { ManageLessonPod } from './ManageLessonPod';
import { ManagePanel } from './ManagePanel';
import { ManageBreadcrumb } from './ManageBreadcrumb';

interface ManageLessonGroupProps {
  className?: string;
  size?: 'md' | 'lg';
  useGrid?: boolean;
  showTitle?: boolean;
  group: PhonicsLessonGroup;
  phonicsClass: PhonicsClassStatus;
  lessonGroups: Array<PhonicsLessonGroup>;
  lessons: Array<PhonicsLesson>;
  onSelectGroup: (group: PhonicsLessonGroup) => void;
  onViewDetail: (lesson: PhonicsLesson) => void;
  onViewResults: (lesson: PhonicsLesson) => void;
  onLaunchLesson: (lesson: PhonicsLesson) => void;
  onAddNotes: (lesson: PhonicsLesson) => void;
}

export const ManageLessonGroup = ({
  size = 'md',
  useGrid = false,
  showTitle = false,
  group,
  phonicsClass,
  lessonGroups,
  lessons,
  onSelectGroup,
  onViewDetail,
  onViewResults,
  onLaunchLesson,
  onAddNotes,
}: ManageLessonGroupProps) => (
  <div className="flex flex-col gap-3">
    <ManageBreadcrumb section="lessons" weekGroup={group} className="my-3" />

    {showTitle && (
      <h2 className="my-3 font-bold text-2xl text-white text-center">
        {group.name}
      </h2>
    )}

    <ManagePanel className="my-3">
      <ManageGroupSelect
        className="w-full max-w-52 mb-6"
        lessonGroups={lessonGroups}
        currentGroup={group}
        onChange={(group) => group && onSelectGroup(group)}
      />

      <div
        className={useGrid ? 'grid grid-cols-3 gap-3' : 'flex flex-wrap gap-6'}
      >
        {lessons.map((lesson) => (
          <ManageLessonPod
            key={lesson.id}
            size={size}
            inverted
            lesson={lesson}
            currentLessonId={phonicsClass.currentLessonId || undefined}
            phonicsClass={phonicsClass}
            onViewDetail={() => onViewDetail(lesson)}
            onViewResults={() => onViewResults(lesson)}
            onLaunchLesson={() => onLaunchLesson(lesson)}
            onAddNotes={() => onAddNotes(lesson)}
          />
        ))}
      </div>
    </ManagePanel>
  </div>
);
